import {
  createRootRoute,
  createRoute,
  createRouter
} from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { ActionDetailPage } from "@/pages/ActionDetailPage";
import { ActionsPage } from "@/pages/ActionsPage";
import { AdminPage } from "@/pages/AdminPage";
import { AdvisoryPage } from "@/pages/AdvisoryPage";
import { AboutPage } from "@/pages/AboutPage";
import { CallbackPage } from "@/pages/CallbackPage";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { ConsolePage } from "@/pages/ConsolePage";
import { CourseDetailPage } from "@/pages/CourseDetailPage";
import { CoursesPage } from "@/pages/CoursesPage";
import { DataExplorerPage } from "@/pages/DataExplorerPage";
import { EngineeringInsightsPage } from "@/pages/EngineeringInsightsPage";
import { ForbiddenPage } from "@/pages/ForbiddenPage";
import { HomePage } from "@/pages/HomePage";
import { JourneyDetailPage } from "@/pages/JourneyDetailPage";
import { JourneyNewPage } from "@/pages/JourneyNewPage";
import { JourneysPage } from "@/pages/JourneysPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { SigninPage } from "@/pages/SigninPage";
import { WorkspacePage } from "@/pages/WorkspacePage";

const rootRoute = createRootRoute({
  component: AppShell
});

const routeTree = rootRoute.addChildren([
  createRoute({ getParentRoute: () => rootRoute, path: "/", component: HomePage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/signin", component: SigninPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/callback", component: CallbackPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/403", component: ForbiddenPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/workspace", component: WorkspacePage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/advisory", component: AdvisoryPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/courses", component: CoursesPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/courses/$courseId",
    component: CourseDetailPage
  }),
  createRoute({ getParentRoute: () => rootRoute, path: "/journeys", component: JourneysPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/journeys/new", component: JourneyNewPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/journeys/$journeyId",
    component: JourneyDetailPage
  }),
  createRoute({ getParentRoute: () => rootRoute, path: "/actions", component: ActionsPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/actions/$requestId",
    component: ActionDetailPage
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/data-explorer",
    component: DataExplorerPage
  }),
  createRoute({ getParentRoute: () => rootRoute, path: "/admin", component: AdminPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/about", component: AboutPage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/console", component: ConsolePage }),
  createRoute({ getParentRoute: () => rootRoute, path: "/profile", component: ProfilePage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/dashboards",
    component: () => <ComingSoonPage feature="Dashboards" />
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/dashboards/engineering-insights",
    component: EngineeringInsightsPage
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/dashboards/$dashboardId",
    component: () => <ComingSoonPage feature="Dashboards" />
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/dashboards/new",
    component: () => <ComingSoonPage feature="Dashboards" />
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: "/reports",
    component: () => <ComingSoonPage feature="Reports" />
  })
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
